// import ALine from "../functions/Line";

import { useState, useEffect } from "react";

// import JSON
import skillsPageJson from '../../configs/skills.json';

export default function Skills() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [isSkillClickEvent, setSkillClickEvent] = useState({})

    const selectItem = (id) => {
        setSkillClickEvent(prevItems => {
            let newVal = { ...prevItems };
            if (newVal[id] === undefined)
            {
                newVal[id] = false;    
            }
            else
            {
                // Do nothing
            }
            
            let tempVal = newVal[id];
            for (const key in prevItems)
            {
                newVal[key] = false;
            }
            newVal[id] = !tempVal;

            return newVal;
        });
    };

    return (
        <div className="SkillsPage">
            <div className="SkillsPage-Container-Outer">
                <div className="SkillsPage-Main-Title">
                    My Skills
                </div>
                <div className="SkillsPage-Proficiency-Container">
                    <div className="SkillsPage-Proficiency-Title">
                        Proficiency
                    </div>
                    <div className="SkillsPage-Proficiency-Tag-Container">
                        <div className="SkillsPage-Proficiency-Tag ElementaryTag">
                            [1] Elementary
                        </div>
                        <div className="SkillsPage-Proficiency-Tag IntermediaryTag">
                            [2] Intermediary
                        </div>
                        <div className="SkillsPage-Proficiency-Tag AdvancedTag">
                            [3] Advanced
                        </div>
                    </div>
                </div>
                <div className="SkillsPage-Container-Inner">
                    {
                        skillsPageJson.map((skillGroup, skillGroupIndex) => {
                            return (
                                <div key={"skillGroup"+skillGroupIndex} className="SkillsPage-SkillGroup-Container">
                                    {
                                        skillGroupIndex === 0 ? "" : <div className="fading-line"/>
                                    }
                                    <div className="SkillsPage-Group-Title">{skillGroup["name"]}</div>
                                    <div className="SkillsPage-SkillGroup-Container-Inner">
                                        {
                                            skillGroup["content"].map((skills, skillsIndex) => {
                                                return (
                                                    <SkillsStyle
                                                        keyVal={"skills"+skillsIndex}
                                                        levelTag={ skills["skillsLevel"]}
                                                        type={skills["type"]}
                                                        icon={skills["image"]}
                                                        name={skills["name"]}
                                                        isClickEvent={isSkillClickEvent[String(skillGroupIndex + "-" + skillsIndex)]}
                                                        setClickEvent={() => selectItem(String(skillGroupIndex + "-" + skillsIndex))}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

function SkillsStyle({ icon, name, keyVal, type, levelTag, isClickEvent, setClickEvent, ...props }) {
    return (
        <div key={keyVal} 
            className={`SkillsPage-Skills-Container ${
                levelTag === "0" ? `ElementaryTag` : 
                levelTag === "1" ? `IntermediaryTag` : 
                levelTag === "2" ? `AdvancedTag` : ""
                } ${isClickEvent ? "" : "hide"}`
            } 
            onClick={setClickEvent}>
            {
                type === "noimage" ? "" : 
                <div className="SkillsPage-Skills-Icon-Container">
                    {
                        type === "text" ? 
                            <div className="SkillsPage-Skills-Icon">{name}</div> :
                        type === "image" ?
                            <img alt="" className="SkillsPage-Skills-Icon" src={icon}/> :
                        ""
                    }
                </div>
            }
            <div className="SkillsPage-Skills-Name">{name}</div>
            <div className={`SkillsPage-Skills-Proficiency ${isClickEvent ? "" : "hide"} ${
                levelTag === "0" ? `ElementaryTag` : 
                levelTag === "1" ? `IntermediaryTag` : 
                levelTag === "2" ? `AdvancedTag` : ""
                }`}>
                <div className="SkillsPage-Skills-Proficiency-Word">
                    Proficiency
                </div>
                <div className="SkillsPage-Skills-Proficiency-Word">
                    {
                        levelTag === "0" ? "1" : 
                        levelTag === "1" ? "2" : 
                        levelTag === "2" ? "3" : "0"
                    }
                </div>
            </div>
        </div>
    )
};